function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 1292,
  height: 530,
  rx: 20,
  fill: "#5492F2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M151.869 536.114C159.929 536.256 167.553 537.677 175.613 538.245C183.455 538.671 191.515 538.813 199.357 539.097C215.694 539.523 232.031 540.091 248.369 540.233C279.955 540.659 311.758 540.801 343.344 540.943C407.386 541.227 470.993 541.227 535.036 541.369C662.685 541.511 790.77 541.653 918.42 541.653C954.58 541.653 990.522 541.653 1026.9 541.795C1063.06 541.795 1099.44 543.074 1135.38 539.239C1149.54 537.819 1149.54 519.071 1135.38 517.651C1103.36 514.243 1071.12 515.095 1038.66 515.095C1007.08 515.095 975.274 515.095 943.689 515.095C879.646 515.095 816.039 515.095 751.996 515.095C624.347 515.095 496.262 514.811 368.612 515.379C332.452 515.521 296.51 515.521 260.132 515.947C242.27 516.089 224.625 516.515 206.545 516.941C197.832 517.225 188.683 517.509 179.752 517.793C170.385 518.219 161.236 519.924 151.652 520.066C141.413 520.35 141.413 535.972 151.869 536.114Z",
  fill: "#2B314F"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 337,
  y: 152,
  width: 511,
  height: 320,
  fill: "#E7EBF3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M777.5 449C796.064 449 811 433.619 811 414.5C811 395.488 795.957 380 777.5 380C758.936 380 744 395.381 744 414.5C744 433.512 759.043 449 777.5 449Z",
  fill: "#FFB614"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M777.659 429.974L775.159 424.555C774.591 423.281 775.614 421.9 777.091 422.006L783.34 422.643C784.817 422.749 785.499 424.449 784.59 425.512L780.84 430.186C780.045 431.355 778.227 431.248 777.659 429.974Z",
  fill: "#2B314F"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M772.992 399.263C770.874 402.776 770.067 407.496 769.059 411.557C768.554 413.313 771.479 413.642 771.176 411.557C771.176 411.447 771.076 411.227 771.076 411.118C770.975 410.679 770.672 410.569 770.37 410.679C770.269 410.679 769.966 410.788 769.865 410.788C770.269 411.227 770.773 411.776 771.176 412.215C772.286 408.154 773.899 403.764 774 399.593C773.798 398.934 773.193 398.824 772.992 399.263Z",
  fill: "#2B314F"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M770.342 412.842C774.086 413.756 778.031 413.413 781.774 413.984C783.19 414.212 783.494 411.929 782.077 411.7C778.334 411.244 773.984 410.444 770.342 411.586C769.938 411.814 769.837 412.728 770.342 412.842Z",
  fill: "#2B314F"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M782.104 412.105C780.824 413.897 780.459 416.532 779.911 418.746C779.545 420.01 778.358 422.54 779.454 423.699C780.002 424.332 781.007 423.91 781.007 422.961C780.916 421.275 781.921 419.062 782.286 417.481C782.652 415.794 783.2 414.108 782.926 412.422C782.835 412 782.378 411.895 782.104 412.105Z",
  fill: "#2B314F"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M778.139 440C763.878 440 751 429.102 751 414.923C751 400.745 762.92 389 777.181 389C791.442 389 804 400.11 804 414.288C804 428.361 792.4 440 778.139 440ZM778.139 390.799C765.155 390.799 754.512 401.38 754.512 414.288C754.512 427.197 765.155 437.778 778.139 437.778C791.122 437.778 801.765 427.197 801.765 414.288C801.765 401.38 791.122 390.799 778.139 390.799Z",
  fill: "#2B314F"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M344.33 158.128C360.78 158.238 377.229 159.449 393.785 159.67C410.023 159.89 426.26 159.89 442.498 159.89C475.185 160 507.872 160 540.559 160C605.934 160 671.202 159.67 736.576 158.568C773.403 157.798 810.335 157.577 847.373 157.247C850.876 157.247 850.876 151.631 847.373 151.631C782.105 151.08 716.731 149.649 651.356 149.208C585.982 148.878 520.607 148.988 455.233 149.208C436.767 149.319 418.194 149.208 399.834 149.429C381.368 149.649 362.902 150.86 344.436 150.97C339.873 151.08 339.873 158.128 344.33 158.128Z",
  fill: "#2B314F"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M343.833 476.3C376.567 476.4 409.301 476.9 442.034 476.9C474.768 477 507.502 476.9 540.129 477C605.596 477 670.958 476.9 736.425 476.5C773.516 476.3 810.501 476.1 847.486 476.1C849.505 476.1 849.505 473.1 847.486 473C782.018 472.8 716.657 472.3 651.19 472.1C585.722 472 520.361 472 454.894 472C417.803 472.1 380.818 472.6 343.833 472.6C341.389 472.7 341.389 476.3 343.833 476.3Z",
  fill: "#2B314F"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M845.744 159.147C845.642 179.602 845.232 200.057 845.232 220.513C845.232 240.457 845.335 260.401 845.335 280.447C845.437 320.846 845.641 361.246 846.153 401.645C846.46 424.555 846.562 447.465 846.767 470.273C846.767 472.216 849.835 472.216 849.937 470.273C850.142 389.474 850.653 308.573 850.346 227.774C850.244 204.864 849.733 181.954 849.528 159.147C849.426 156.794 845.744 156.794 845.744 159.147Z",
  fill: "#2B314F"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M337.589 153.835C337.471 175.114 337 196.393 337 217.671C337 238.418 337.118 259.165 337.118 280.018C337.236 322.043 337.471 364.069 338.06 406.094C338.414 429.926 338.531 453.758 338.767 477.484C338.767 479.505 342.301 479.505 342.419 477.484C342.654 393.433 343.243 309.276 342.89 225.225C342.772 201.393 342.183 177.561 341.947 153.835C341.712 151.388 337.589 151.388 337.589 153.835Z",
  fill: "#2B314F"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M876.38 241.855C876.278 241.855 876.278 241.855 876.278 241.855C876.482 241.753 876.687 241.548 876.891 241.446C876.789 241.548 876.789 241.548 876.789 241.548C876.38 242.06 875.562 242.162 874.948 241.957C874.334 241.753 873.823 241.037 873.925 240.423C873.925 239.81 874.232 239.298 874.743 238.991C875.357 238.582 876.278 238.684 876.789 239.298C876.891 239.4 876.891 239.4 876.891 239.4C876.687 239.298 876.482 239.094 876.278 238.991C876.38 238.991 876.38 238.991 876.38 238.991C877.709 239.298 877.709 241.548 876.38 241.855Z",
  fill: "#2B314F"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M869.733 246.048C871.779 246.048 871.779 242.877 869.733 242.877C867.688 242.877 867.688 246.048 869.733 246.048Z",
  fill: "#2B314F"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M863.184 249.525C865.025 249.525 865.025 246.662 863.184 246.662C861.241 246.662 861.241 249.525 863.184 249.525Z",
  fill: "#2B314F"
})));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M857.664 254.435C859.811 254.435 859.811 251.162 857.664 251.162C855.516 251.265 855.516 254.435 857.664 254.435Z",
  fill: "#2B314F"
})));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M850.709 258.015C850.709 257.912 850.709 257.912 850.709 257.81C850.811 258.015 850.811 258.219 850.914 258.424C850.914 258.424 850.913 258.321 850.811 258.321C850.3 257.401 850.914 256.071 852.039 256.071C853.164 256.071 853.777 257.299 853.266 258.321C853.266 258.321 853.266 258.424 853.164 258.424C853.266 258.219 853.266 258.015 853.368 257.81C853.368 257.912 853.368 257.912 853.368 258.015C853.266 258.73 852.754 259.446 852.039 259.344C851.323 259.344 850.811 258.73 850.709 258.015Z",
  fill: "#2B314F"
});

var _ref20 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M847.741 263.538C849.684 263.538 849.684 260.367 847.741 260.367C845.696 260.469 845.696 263.538 847.741 263.538Z",
  fill: "#2B314F"
})));

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M364.237 419.607C383.592 402.265 401.671 383.425 419.963 365.013C429.109 355.807 438.361 346.6 447.4 337.394C456.44 328.295 466.33 319.303 474.625 309.562C475.795 308.063 473.987 306.136 472.498 307.421C462.821 315.985 454.206 326.047 445.061 335.146C435.915 344.352 426.769 353.559 417.623 362.765C399.225 381.07 380.189 398.947 362.323 417.68C361.259 419.072 363.067 420.785 364.237 419.607Z",
  fill: "#2B314F"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M519.288 347.663C532.666 335.943 545.194 322.945 557.828 310.479C563.986 304.406 570.144 298.227 576.302 292.154C582.673 285.761 589.68 279.475 595.626 272.55C596.794 271.058 594.989 269.14 593.502 270.419C586.813 276.172 580.868 283.098 574.497 289.384C568.127 295.776 561.863 301.956 555.493 308.242C542.858 320.814 529.587 332.853 517.377 345.958C516.209 347.023 518.014 348.728 519.288 347.663Z",
  fill: "#2B314F"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M749.423 343.344C763.243 318.084 775.467 291.872 788.118 265.978C794.496 252.978 800.662 240.084 806.933 226.978C812.993 214.401 819.796 201.93 824.899 188.824C825.537 187.239 822.985 186.288 822.135 187.662C815.225 200.133 809.591 213.767 803.425 226.661C797.366 239.344 791.094 252.238 784.929 264.921C772.385 290.604 759.097 315.97 747.084 341.97C746.553 343.555 748.679 344.823 749.423 343.344Z",
  fill: "#2B314F"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M473.329 309.274C480.036 316.483 487.791 322.739 495.231 329.206C502.252 335.461 509.169 342.247 516.819 347.76C518.181 348.714 519.753 346.594 518.6 345.427C511.684 338.536 503.719 332.387 496.384 325.919C489.363 319.664 482.446 312.879 474.901 307.259C473.644 306.305 472.386 308.214 473.329 309.274Z",
  fill: "#2B314F"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M593.384 272.198C599.978 279.894 607.828 286.615 615.26 293.661C622.273 300.382 629.181 307.645 636.821 313.715C638.182 314.799 639.752 312.523 638.601 311.33C631.902 304.068 624.157 297.672 616.934 290.843C609.712 284.013 602.909 276.642 595.268 270.355C593.908 269.271 592.233 270.897 593.384 272.198Z",
  fill: "#2B314F"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M681.1 272.212C673.277 277.726 666.203 284.407 658.915 290.664C651.413 297.133 643.268 303.389 636.409 310.388C635.23 311.555 636.838 313.782 638.231 312.721C645.84 306.995 652.806 300.102 659.987 293.845C667.489 287.377 675.634 281.226 682.601 274.227C683.673 273.272 682.386 271.364 681.1 272.212Z",
  fill: "#2B314F"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M679.337 273.22C689.83 285.774 701.716 297.471 713.066 309.274C718.634 315.069 724.309 320.863 729.877 326.765C735.659 332.667 741.12 339.105 747.437 344.578C748.936 345.866 750.864 343.934 749.579 342.432C744.439 336.315 738.336 330.843 732.768 325.048C726.879 319.039 721.204 313.03 715.422 307.021C704.071 295.217 693.15 282.77 681.264 271.395C679.979 270.215 678.266 271.932 679.337 273.22Z",
  fill: "#2B314F"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M474 315C476.813 315 479 312.708 479 310C479 307.188 476.708 305 474 305C471.188 305 469 307.292 469 310C469 312.812 471.188 315 474 315Z",
  fill: "#2B314F"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M594 278C596.812 278 599 275.708 599 273C599 270.188 596.708 268 594 268C591.187 268 589 270.292 589 273C589 275.708 591.292 278 594 278Z",
  fill: "#2B314F"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M682 279C684.813 279 687 276.708 687 274C687 271.188 684.708 269 682 269C679.187 269 677 271.292 677 274C677 276.708 679.292 279 682 279Z",
  fill: "#2B314F"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M748 347C750.813 347 753 344.708 753 342C753 339.188 750.708 337 748 337C745.187 337 743 339.292 743 342C743 344.708 745.187 347 748 347Z",
  fill: "#2B314F"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M475.609 327L474.975 317.582L472.862 309.54L460.607 293.667L453 276.312L458.599 254.407L465.889 238.429L478.673 231.021L493.57 227L509.946 229.328L523.258 236.206L532.661 246.788L539 259.91L538.789 274.196L534.774 288.693L523.892 304.355L518.398 314.09L516.391 320.862L517.236 326.471L475.609 327Z",
  fill: "#FFB614"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M477 355L477.628 364.522L484.12 372.184L493.649 377L501.188 376.343L508.099 373.716L513.859 369.776L515.325 363.537L517 358.831L516.895 355.109H477V355Z",
  fill: "#FFB614"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M526.657 333.048C528.145 328.437 524.531 327.179 520.811 327.284C517.834 327.284 514.858 327.179 511.882 326.969C511.669 326.865 511.35 326.76 511.031 326.655C508.48 326.131 506.035 325.921 503.59 326.026C502.953 326.026 502.421 326.236 501.89 326.655C501.252 326.76 500.827 326.865 500.401 327.074C500.189 326.969 499.87 326.969 499.551 326.969C493.067 327.284 486.583 327.179 480.099 326.655C479.567 326.55 479.142 326.76 478.61 326.969C476.378 326.76 474.04 326.55 472.126 327.389C469.788 328.332 468.831 330.952 469.681 333.258C470.107 334.41 470.744 335.144 471.595 335.773C470.957 335.983 470.425 336.192 470 336.507C468.087 337.659 467.449 340.07 468.512 342.061C469.15 343.528 470.532 344.262 471.914 344.576C472.339 345.205 472.977 345.729 473.721 345.834C474.784 346.044 475.847 346.148 476.91 346.253C475.103 346.253 473.189 346.358 471.382 346.358C467.981 346.463 467.449 350.76 469.681 352.122C469.256 353.799 470.319 356 472.551 356C481.268 356 489.984 356 498.701 355.895C502.953 355.79 507.205 355.79 511.456 355.686C515.389 355.581 519.641 355.895 523.362 354.742C525.594 354.009 526.126 351.808 525.063 350.131C525.169 349.712 525.275 349.502 525.275 349.083C525.275 348.245 524.956 347.511 524.318 346.882C523.893 346.568 523.574 346.358 523.149 346.148C523.149 345.939 523.149 345.729 523.149 345.52C524.637 344.891 525.488 343.214 525.275 341.432C525.275 341.328 525.275 341.223 525.275 341.223C525.7 339.441 524.637 337.345 522.405 337.345C522.299 337.345 522.086 337.031 521.98 336.926C524.212 336.192 525.913 335.249 526.657 333.048Z",
  fill: "#DCE7F7"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M527 331.635V330.351C527 327.462 524.458 325 521.28 325L496.917 325.107V325.214L473.932 325.107C470.754 325.107 468.106 327.355 468 330.244V331.528C468 333.348 468.953 334.953 470.542 336.023C469.059 336.987 468 338.485 468 340.197V341.482C468 343.301 468.953 344.906 470.542 345.977C469.059 346.94 468 348.438 468 350.15V351.435C468 354.324 470.542 356.786 473.826 356.893L502.002 357H501.896H521.068C524.14 357 526.788 354.645 526.788 351.863V350.579C526.788 348.866 525.835 347.154 524.352 346.191C525.835 345.227 526.788 343.729 526.788 341.91V340.625C526.788 338.913 525.835 337.201 524.352 336.237C525.941 334.846 527 333.348 527 331.635ZM524.246 331.635C524.246 332.599 523.716 333.455 522.869 333.99C522.763 334.953 522.339 335.702 521.386 336.13C520.75 336.344 520.221 336.559 519.585 336.773H521.386C521.704 336.773 522.022 336.773 522.339 336.666C523.822 336.88 524.352 338.806 524.352 340.197V341.482C524.352 342.98 523.081 344.264 521.492 344.264L516.937 344.371C517.361 344.692 517.573 345.12 517.785 345.763C517.89 346.084 517.891 346.405 517.891 346.726H521.492C521.81 346.726 522.127 346.726 522.445 346.619C523.928 346.833 524.458 348.759 524.458 350.15V351.435C524.458 352.933 523.187 354.217 521.598 354.217L483.147 354.86H483.359L473.508 354.753C471.813 354.753 471.072 352.719 471.178 351.114V349.829C471.178 348.331 472.555 347.047 474.25 347.047L502.32 346.619C502.32 345.763 502.637 345.013 503.273 344.371L484.63 344.692L474.461 344.585C474.144 344.585 473.826 344.585 473.508 344.692C472.025 344.478 471.39 342.552 471.39 341.054V339.769C471.39 338.271 472.767 336.987 474.461 336.987L485.478 336.88C485.054 336.237 484.948 335.381 485.054 334.739H484.524L474.355 334.632C474.038 334.632 473.72 334.632 473.402 334.739C471.919 334.525 471.284 332.599 471.284 331.1V329.816C471.284 328.318 472.661 327.033 474.355 327.033L507.934 326.498H507.828L522.233 326.391C523.928 326.391 524.564 328.425 524.564 330.03L524.246 331.635Z",
  fill: "#2B314F"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M495.017 189.036C494.339 193.71 494.339 198.277 494.226 203.058C494.226 205.288 494.113 207.519 494.113 209.75C494.113 210.918 494 212.299 494 213.362C494.113 214.212 494.565 214.849 494.678 215.805C494.791 217.398 497.163 217.398 497.276 215.805C497.388 214.849 497.84 214.212 497.953 213.362C498.066 212.193 497.953 210.812 497.84 209.75C497.84 207.519 497.727 205.288 497.727 203.058C497.614 198.384 497.614 193.71 497.05 189.036C496.937 187.655 495.13 187.655 495.017 189.036Z",
  fill: "#2B314F"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M441.217 214.778C444.137 218.242 447.37 221.399 450.603 224.659C452.167 226.187 453.732 227.613 455.296 229.141C456.13 229.956 456.964 230.873 457.799 231.586C458.424 232.096 459.259 232.197 459.989 232.707C461.136 233.624 462.7 232.197 461.657 231.077C461.032 230.466 460.927 229.651 460.406 229.04C459.676 228.123 458.633 227.41 457.799 226.595C456.026 224.965 454.253 223.335 452.584 221.807C449.247 218.751 446.014 215.899 442.364 213.148C441.426 212.537 440.591 213.963 441.217 214.778Z",
  fill: "#2B314F"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M419.691 267.518C424.252 268.202 428.708 268.43 433.375 268.658C435.814 268.772 438.254 268.772 440.694 268.886C441.649 268.886 442.709 269 443.77 269C444.831 268.886 445.785 268.544 446.846 268.43C448.437 268.316 448.331 265.921 446.846 265.807C445.891 265.693 445.255 265.237 444.406 265.123C443.24 265.009 441.861 265.123 440.8 265.123C438.572 265.123 436.345 265.123 434.117 265.009C429.45 265.009 424.783 264.895 420.116 265.465C418.949 265.579 418.524 267.404 419.691 267.518Z",
  fill: "#2B314F"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M439.496 323.801C443.22 321.216 446.624 318.216 450.134 315.32C451.943 313.769 453.751 312.114 455.56 310.563C456.304 309.942 457.155 309.322 457.9 308.598C458.538 307.874 458.964 306.943 459.709 306.115C460.56 305.185 459.389 303.323 458.219 304.254C457.368 304.874 456.517 305.081 455.666 305.702C454.709 306.322 453.858 307.356 453.007 308.184C451.411 309.632 449.709 311.183 448.113 312.735C444.709 315.941 441.305 319.044 438.22 322.56C437.582 323.077 438.433 324.525 439.496 323.801Z",
  fill: "#2B314F"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M471 203.012C471.103 205.739 472.345 208.36 473.275 210.877C474.31 213.709 475.24 216.016 476.792 218.428C477.516 219.582 479.274 218.848 478.964 217.485C478.447 214.653 477.516 212.241 476.275 209.514C475.24 206.997 474.31 204.375 472.551 202.278C472.138 201.648 471 202.173 471 203.012Z",
  fill: "#2B314F"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M429.303 238.625C431.324 240.567 433.982 241.538 436.535 242.833C439.193 244.128 441.533 245.207 444.51 245.962C445.893 246.286 446.531 244.452 445.468 243.696C442.915 241.862 440.15 240.675 437.173 239.488C434.833 238.517 432.494 237.223 430.048 237.007C429.091 236.899 428.665 238.086 429.303 238.625Z",
  fill: "#2B314F"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M429.96 293C432.738 293 435.31 291.764 437.78 290.864C440.558 289.853 442.924 289.066 445.394 287.38C446.628 286.593 445.805 284.794 444.468 285.019C441.484 285.469 438.809 286.593 435.928 287.829C433.664 288.841 431.298 289.515 429.343 291.202C428.623 291.876 429.137 293 429.96 293Z",
  fill: "#2B314F"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M551.636 213.185C548.09 215.837 544.753 218.795 541.416 221.854C539.747 223.486 537.87 225.118 536.201 226.648C535.471 227.26 534.637 227.973 534.011 228.585C533.386 229.401 532.968 230.217 532.343 231.033C531.3 232.155 532.864 233.685 534.011 232.665C534.637 232.155 535.471 232.053 536.201 231.543C537.14 230.931 537.87 229.911 538.704 229.095C540.268 227.566 541.833 226.138 543.397 224.608C546.734 221.344 549.863 218.285 552.783 214.715C553.409 214.001 552.574 212.471 551.636 213.185Z",
  fill: "#2B314F"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M574.979 265.454C570.296 265 565.613 265 560.93 265C558.695 265 556.46 265 554.225 265.113C553.054 265.113 551.67 265 550.606 265.113C549.754 265.227 549.116 265.794 548.158 265.794C546.668 265.907 546.561 268.288 548.158 268.401C549.116 268.515 549.754 268.968 550.606 268.968C551.777 269.082 553.16 268.855 554.225 268.855C556.673 268.741 559.121 268.741 561.569 268.628C566.252 268.515 570.722 268.175 575.299 267.494C576.47 267.381 576.044 265.567 574.979 265.454Z",
  fill: "#2B314F"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M555.78 322.333C552.695 318.67 549.397 315.438 545.887 312.099C544.291 310.59 542.589 308.974 540.993 307.358C540.142 306.496 539.291 305.527 538.334 304.773C537.589 304.126 536.632 304.018 535.781 303.264C534.611 302.295 533.44 304.234 534.291 305.203C534.93 305.85 535.036 306.712 535.674 307.358C536.419 308.22 537.483 309.082 538.44 309.836C540.249 311.452 542.057 313.176 543.866 314.792C547.27 317.916 550.78 320.933 554.504 323.626C555.567 324.704 556.418 323.195 555.78 322.333Z",
  fill: "#2B314F"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M522.23 202.232C520.253 204.23 519.206 206.964 518.043 209.488C516.764 212.222 515.601 214.536 515.02 217.48C514.787 218.847 516.648 219.584 517.462 218.427C519.206 216.008 520.253 213.589 521.416 210.855C522.462 208.331 523.974 205.702 523.974 202.968C524.207 202.127 522.811 201.706 522.23 202.232Z",
  fill: "#2B314F"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M563.952 237.007C561.4 237.223 559.06 238.517 556.827 239.488C553.85 240.675 551.191 241.862 548.532 243.696C547.469 244.452 548.107 246.286 549.489 245.962C552.361 245.315 554.7 244.236 557.465 242.833C559.911 241.646 562.676 240.567 564.697 238.625C565.335 238.086 564.909 236.899 563.952 237.007Z",
  fill: "#2B314F"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M565.727 291.198C563.644 289.509 561.122 288.721 558.71 287.82C555.639 286.582 552.788 285.456 549.608 285.005C548.292 284.893 547.306 286.582 548.621 287.37C551.253 288.946 553.775 289.847 556.736 290.861C559.368 291.761 562.219 293 565.07 293C565.727 292.887 566.385 291.761 565.727 291.198Z",
  fill: "#2B314F"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M510.083 323.939C510.487 319.972 510.184 316.005 510.487 312.039C510.891 307.643 511.497 303.462 512.406 299.174C513.316 295.208 514.629 291.348 516.144 287.596C516.952 285.667 517.76 283.844 518.67 282.022C519.579 280.306 520.69 278.698 520.993 276.769C521.094 275.804 520.084 274.41 519.074 275.268C516.144 277.626 514.528 282.558 513.114 286.095C511.497 290.062 510.184 294.136 509.275 298.317C507.457 306.357 505.941 316.113 507.962 324.26C508.366 325.439 509.881 325.118 510.083 323.939Z",
  fill: "#2B314F"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M492.97 326.182C495.134 318.042 493.511 308.296 491.563 300.263C490.588 296.086 489.181 292.017 487.45 288.054C485.934 284.627 484.311 279.486 481.064 277.237C479.982 276.487 478.899 277.665 479.007 278.736C479.332 280.664 480.523 282.163 481.497 283.984C482.363 285.59 483.12 287.197 483.878 288.803C485.718 292.766 487.017 296.943 488.099 301.12C489.073 305.19 489.831 309.26 490.156 313.437C490.48 317.614 490.264 321.684 490.588 325.861C490.805 327.146 492.645 327.467 492.97 326.182Z",
  fill: "#2B314F"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M478.5 280C480.359 280 482 278.256 482 276C482 273.846 480.469 272 478.5 272C476.641 272 475 273.744 475 276C475 278.256 476.531 280 478.5 280Z",
  fill: "#2B314F"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M519 280C520.594 280 522 278.256 522 276C522 273.846 520.687 272 519 272C517.406 272 516 273.744 516 276C516 278.256 517.406 280 519 280Z",
  fill: "#2B314F"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M516.352 355C516.352 355 516.458 355.648 516.458 356.188C516.458 366.878 507.985 374.545 497.5 374.545C487.015 374.545 478.542 366.878 478.542 356.188C478.542 355.756 478.542 355 478.648 355H476.106C476.106 355 476 355.648 476 356.188C476 368.282 485.638 378 497.5 378C509.362 378 519 368.39 519 356.296C519 355.864 519 355.108 518.894 355.108L516.352 355Z",
  fill: "#2B314F"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M518.589 325.439C516.592 313.109 527.206 304.181 533.407 294.934C538.767 286.962 541.289 277.503 540.974 267.831C540.343 249.018 528.468 232.543 510.496 227.016C500.723 224.04 490.003 224.359 480.439 227.973C477.917 228.929 478.968 232.968 481.595 232.012C497.99 225.847 518.273 230.205 528.993 244.872C534.353 252.313 536.98 261.453 536.875 270.594C536.77 280.479 532.987 288.982 527.101 296.847C520.796 305.244 513.439 314.916 516.171 326.076C516.592 327.671 518.799 327.033 518.589 325.439Z",
  fill: "#2B314F"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M472.027 337.522C479.256 337.96 486.375 338.07 493.604 337.96C495.465 337.96 495.465 335 493.604 335C486.484 335.11 479.256 335.219 472.027 335.329C470.603 335.329 470.713 337.412 472.027 337.522Z",
  fill: "#2B314F"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M472.041 346.747C482.289 347.064 492.537 347.064 502.679 346.853C504.387 346.853 504.493 344 502.679 344C492.537 344.106 482.182 344.423 472.041 344.528C470.653 344.74 470.653 346.747 472.041 346.747Z",
  fill: "#2B314F"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M504.037 336.956C510.31 337.062 516.477 336.956 522.644 336.851C524.452 336.851 524.452 334 522.644 334C516.371 334.106 510.204 334.528 504.037 334.739C502.654 334.845 502.654 336.851 504.037 336.956Z",
  fill: "#2B314F"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M523.197 344.536C522.53 344.429 522.085 344.107 521.419 344.107C520.752 344 520.085 344 519.307 344C518.084 344 516.64 344.107 515.417 344.107C513.528 344 513.528 346.893 515.417 347C516.64 347 517.862 347 519.085 346.893C520.307 346.893 521.641 346.679 522.863 346.679C524.197 346.679 524.419 344.75 523.197 344.536Z",
  fill: "#2B314F"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M513.357 229.052C495.475 221.439 476.104 228.735 464.502 243.538C453.326 257.707 451.729 278.96 461.202 294.398C464.076 299.05 468.334 302.54 471.207 307.192C473.975 311.845 475.891 317.132 474.613 322.418C474.081 324.956 478.019 326.119 478.658 323.582C480.361 316.074 477.487 308.038 472.698 302.011C469.93 298.416 466.631 295.455 464.395 291.437C462.16 287.631 460.776 283.401 459.925 279.066C456.519 260.879 465.779 242.587 482.064 233.916C491.537 228.947 502.075 228.101 512.186 231.379C513.676 231.696 514.741 229.581 513.357 229.052Z",
  fill: "white"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M513.35 228.574C496.753 221.414 476.221 225.154 463.774 238.512C450.901 252.404 448.347 274.418 457.284 291.088C463.135 301.775 476.753 311.713 473.88 325.391C473.348 327.956 477.391 329.131 477.923 326.566C479.944 316.628 474.625 307.866 468.88 300.278C462.816 292.264 457.709 284.463 456.539 274.204C454.518 255.503 464.837 237.337 482.71 231.139C492.392 227.719 502.605 227.719 512.392 230.925C513.669 231.246 514.733 229.108 513.35 228.574Z",
  fill: "#2B314F"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M270.256 447L222.017 432.997L211 380.697L213.567 380.167C217.097 379.318 220.84 379 224.477 379C251.752 379 274 400.959 274 428.011C274 433.633 273.037 439.256 271.112 444.666L270.256 447ZM226.616 428.86L266.834 440.529C268.01 436.392 268.652 432.254 268.652 428.011C268.652 403.93 248.864 384.304 224.477 384.304C222.017 384.304 219.664 384.516 217.311 384.835L226.616 428.86Z",
  fill: "#2B314F"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M217.11 437.13L207.169 389C186.546 393.685 171 412.213 171 434.468C171 460.236 191.729 481 217.322 481C237.416 481 254.549 468.116 261 450.014L217.11 437.13Z",
  fill: "#E7EBF3"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M217.461 483C190.22 483 168 461.151 168 434.236C168 411.649 184.238 391.594 206.565 386.633L209.236 386L219.491 434.764L265 447.852L264.039 450.491C257.095 469.912 238.293 483 217.461 483ZM205.069 392.439C186.481 397.822 173.341 414.921 173.341 434.236C173.341 458.196 193.105 477.723 217.461 477.723C235.195 477.723 251.112 467.273 257.949 451.335L214.898 438.88L205.069 392.439Z",
  fill: "#2B314F"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M101.758 211.183C101.339 223.739 100.083 236.188 100.083 248.744C100.083 254.969 100.083 261.194 100.083 267.313C100.083 273.855 99.4549 280.502 101.653 286.727C103.747 292.529 111.075 292.318 113.169 286.727C115.472 280.502 114.949 273.855 114.949 267.313C114.949 261.088 114.949 254.863 114.844 248.744C114.74 236.188 113.274 223.739 112.436 211.183C112.018 204.325 101.967 204.22 101.758 211.183Z",
  fill: "#2B314F"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M131.758 176.213C131.339 194.63 130.083 212.835 130.083 231.146C130.083 240.248 130.083 249.456 130.083 258.559C130.083 267.979 129.455 277.505 131.653 286.713C133.119 292.429 141.599 292.429 143.169 286.713C145.472 277.717 144.949 268.508 144.949 259.194C144.949 249.774 144.949 240.46 144.844 231.04C144.739 212.623 143.274 194.418 142.436 176.107C142.227 169.333 131.967 169.227 131.758 176.213Z",
  fill: "#2B314F"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M162.764 218.198C162.344 229.549 161.188 240.793 161.083 252.25C161.083 257.766 161.083 263.176 161.083 268.692C161.083 274.738 160.453 280.997 162.659 286.619C163.604 288.953 165.075 290.65 167.596 290.968C169.697 291.181 172.533 290.332 173.583 288.104C176.104 282.27 175.999 276.436 175.999 270.177C175.999 264.449 175.999 258.72 175.894 252.992C175.789 241.323 174.319 229.867 173.478 218.304C173.058 211.303 162.974 211.197 162.764 218.198Z",
  fill: "#2B314F"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M192.764 218.198C192.344 229.549 191.188 240.793 191.083 252.25C191.083 257.766 191.083 263.176 191.083 268.692C191.083 274.738 190.453 280.997 192.659 286.619C193.604 288.953 195.075 290.65 197.596 290.968C199.697 291.181 202.533 290.332 203.583 288.104C206.104 282.27 205.999 276.436 205.999 270.177C205.999 264.449 205.999 258.72 205.894 252.992C205.789 241.323 204.319 229.867 203.478 218.304C203.058 211.303 192.974 211.197 192.764 218.198Z",
  fill: "#2B314F"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M223.844 244.145C223.423 251.426 222.265 258.602 222.16 265.989C222.16 269.366 222.16 272.849 222.055 276.331C221.95 280.447 221.739 284.562 224.265 288.15C227.106 292.055 231.842 291.844 234.579 288.15C237.105 284.668 236.999 280.447 236.999 276.331C236.999 272.954 236.999 269.472 236.999 265.989C236.894 258.602 235.421 251.532 234.579 244.145C233.842 237.391 224.265 237.18 223.844 244.145Z",
  fill: "#2B314F"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M253.758 212.237C253.339 224.615 252.083 236.781 252.083 249.159C252.083 255.295 252.083 261.325 252.083 267.567C252.083 274.02 251.455 280.579 253.653 286.715C255.747 292.534 262.971 292.322 265.169 286.715C267.472 280.685 266.949 274.02 266.949 267.567C266.949 261.536 266.949 255.4 266.844 249.159C266.74 236.781 265.274 224.509 264.436 212.237C264.122 205.361 253.967 205.149 253.758 212.237Z",
  fill: "#2B314F"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M1030.1 169.341C1029.8 187.137 1028.67 204.729 1028.67 222.423C1028.67 231.218 1028.67 240.116 1028.67 248.912C1028.57 258.015 1028.06 267.22 1030.21 276.118C1031.64 281.641 1039.92 281.641 1041.46 276.118C1043.71 267.424 1043.19 258.526 1043.19 249.526C1043.19 240.423 1043.19 231.423 1043.09 222.32C1042.99 204.524 1041.46 186.932 1040.64 169.239C1040.23 162.693 1030.21 162.591 1030.1 169.341Z",
  fill: "#2B314F"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M1059.56 210.865C1059.15 221.706 1058.02 232.445 1057.92 243.287C1057.92 248.503 1057.92 253.719 1057.92 258.935C1057.92 264.663 1057.31 270.697 1059.46 276.118C1060.38 278.368 1061.81 280.004 1064.26 280.311C1066.31 280.516 1069.07 279.697 1070.09 277.55C1072.55 272.027 1072.44 266.401 1072.44 260.367C1072.44 254.946 1072.44 249.423 1072.34 244.003C1072.24 232.855 1070.81 221.911 1069.99 210.865C1069.48 204.217 1059.76 204.115 1059.56 210.865Z",
  fill: "#2B314F"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M1088.71 181.103C1088.3 196.853 1087.17 212.604 1087.17 228.354C1087.17 236.23 1087.17 244.003 1087.17 251.878C1087.17 260.06 1086.56 268.242 1088.81 276.118C1090.34 281.743 1098.42 281.641 1100.06 276.118C1102.21 268.447 1101.7 260.469 1101.7 252.594C1101.7 244.514 1101.7 236.434 1101.6 228.354C1101.49 212.604 1099.96 196.853 1099.14 181.103C1098.83 174.455 1088.91 174.352 1088.71 181.103Z",
  fill: "#2B314F"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M1118.26 210.252C1117.86 221.195 1116.73 232.037 1116.63 243.082C1116.63 248.401 1116.63 253.617 1116.63 258.935C1116.63 264.765 1116.01 270.799 1118.16 276.22C1119.08 278.47 1120.51 280.107 1122.97 280.414C1125.01 280.618 1127.78 279.8 1128.8 277.652C1131.25 272.027 1131.15 266.402 1131.15 260.367C1131.15 254.844 1131.15 249.321 1131.05 243.798C1130.95 232.548 1129.51 221.502 1128.7 210.354C1128.19 203.604 1118.47 203.501 1118.26 210.252Z",
  fill: "#2B314F"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M1154.47 235.002C1154.06 242.059 1152.94 249.014 1152.83 256.173C1152.83 259.446 1152.83 262.821 1152.73 266.197C1152.63 270.185 1152.42 274.174 1154.88 277.652C1157.64 281.436 1162.24 281.231 1164.9 277.652C1167.36 274.276 1167.25 270.185 1167.25 266.197C1167.25 262.924 1167.25 259.549 1167.25 256.173C1167.15 249.014 1165.72 242.162 1164.9 235.002C1164.19 228.456 1154.88 228.252 1154.47 235.002Z",
  fill: "#2B314F"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M1183.11 241.344C1182.7 247.583 1181.47 253.617 1181.47 259.958C1181.47 266.504 1180.04 273.357 1184.44 278.777C1186.38 281.13 1190.78 281.027 1192.62 278.777C1197.12 273.561 1196 265.89 1195.89 259.345C1195.79 252.697 1194.26 246.458 1193.44 240.014C1192.52 233.776 1183.52 235.821 1183.11 241.344Z",
  fill: "#2B314F"
});

var _ref76 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M892.54 294.425C894.483 294.425 894.483 291.255 892.54 291.255C890.494 291.255 890.494 294.425 892.54 294.425Z",
  fill: "#2B314F"
})));

var _ref77 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M875.553 290.209C871.75 288.559 868.808 285.404 867.373 281.244C865.866 276.941 866.153 272.28 868.162 268.407C872.539 260.232 880.648 259.156 886.747 261.666C893.348 264.463 898.515 271.706 895.788 280.312C895.358 281.961 894.568 283.468 893.42 284.974C890.335 288.99 885.67 291.285 881.006 291.285C879.141 291.285 877.275 290.926 875.553 290.209ZM870.028 269.411C868.305 272.71 868.019 276.798 869.382 280.527C870.674 284.113 873.113 286.838 876.414 288.201C881.652 290.424 887.967 288.559 891.698 283.683C892.703 282.392 893.348 281.101 893.707 279.738C896.075 272.352 891.554 266.112 885.886 263.674C884.307 263.029 882.513 262.598 880.648 262.598C876.773 262.598 872.683 264.391 870.028 269.411Z",
  fill: "#2B314F"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M844.841 242.088C844.769 242.088 844.769 242.088 844.698 242.088C844.913 241.944 845.128 241.801 845.343 241.729C845.272 241.801 845.272 241.801 845.2 241.873C844.769 242.375 843.98 242.446 843.406 242.231C842.832 242.016 842.33 241.371 842.401 240.725C842.401 240.152 842.688 239.578 843.191 239.291C843.765 238.932 844.698 239.004 845.2 239.578C845.272 239.65 845.272 239.65 845.343 239.721C845.128 239.578 844.913 239.434 844.698 239.363C844.769 239.363 844.769 239.363 844.841 239.363C846.204 239.578 846.204 241.801 844.841 242.088Z",
  fill: "#2B314F"
});

var _ref79 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M838.384 246.176C840.393 246.176 840.393 243.092 838.384 243.092C836.375 243.092 836.375 246.176 838.384 246.176Z",
  fill: "#2B314F"
})));

var _ref80 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M831.925 249.618C833.719 249.618 833.719 246.821 831.925 246.821C830.059 246.821 830.059 249.618 831.925 249.618Z",
  fill: "#2B314F"
})));

var _ref81 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M826.543 254.423C828.624 254.423 828.624 251.196 826.543 251.196C824.462 251.267 824.462 254.423 826.543 254.423Z",
  fill: "#2B314F"
})));

var _ref82 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M819.799 257.865C819.799 257.793 819.799 257.722 819.799 257.65C819.871 257.865 819.943 258.08 820.014 258.295C820.014 258.295 820.015 258.224 819.943 258.224C819.44 257.291 820.086 256.072 821.163 256.072C822.239 256.072 822.885 257.291 822.383 258.224C822.383 258.224 822.382 258.295 822.311 258.295C822.382 258.08 822.454 257.865 822.526 257.65C822.526 257.722 822.526 257.793 822.526 257.865C822.454 258.582 821.952 259.228 821.234 259.156C820.373 259.156 819.871 258.582 819.799 257.865Z",
  fill: "#2B314F"
});

var _ref83 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M816.856 263.315C818.794 263.315 818.794 260.232 816.856 260.232C814.847 260.303 814.847 263.315 816.856 263.315Z",
  fill: "#2B314F"
})));

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M813.125 243.522L813.914 364.291C813.914 366.012 815.349 367.375 817.215 367.375L907.772 366.801C905.332 370.53 908.274 363.215 908.274 361.494L906.91 244.024C906.91 243.379 906.839 242.733 906.767 242.088C906.265 239.004 903.179 241.012 906.049 240.94C907.484 240.94 899.017 240.08 895.716 240.08L816.354 240.367C814.56 240.438 813.125 241.801 813.125 243.522Z",
  fill: "url(#paint0_linear)"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M814.13 238.861C845.201 238.861 876.343 238.502 907.413 238C909.494 238 909.494 241.155 907.413 241.227C876.271 241.729 845.201 241.729 814.13 241.227C812.623 241.227 812.623 238.861 814.13 238.861Z",
  fill: "#2B314F"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M814.13 365.08C845.201 365.08 876.343 364.721 907.413 364.219C909.494 364.219 909.494 367.375 907.413 367.446C876.271 367.948 845.201 367.948 814.13 367.446C812.623 367.446 812.623 365.08 814.13 365.08Z",
  fill: "#2B314F"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M815.925 239.865C816.069 282.033 816.356 324.202 816.786 366.371C816.786 368.45 813.557 368.45 813.557 366.371C813.127 324.202 813.127 282.033 813.485 239.865C813.557 238.359 815.925 238.359 815.925 239.865Z",
  fill: "#2B314F"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M829.917 256.789C844.771 256.718 859.767 256.431 874.621 255.929C876.702 255.857 876.702 259.084 874.621 259.156C859.696 259.658 844.842 259.586 829.917 259.156C828.41 259.156 828.338 256.789 829.917 256.789Z",
  fill: "#2B314F"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M829.917 279.738C849.578 279.738 869.311 279.38 888.972 278.878C891.053 278.806 891.053 282.033 888.972 282.105C869.239 282.607 849.578 282.535 829.917 282.105C828.41 282.105 828.338 279.738 829.917 279.738Z",
  fill: "#2B314F"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M829.917 294.081C849.578 294.081 869.311 293.723 888.972 293.221C891.053 293.149 891.053 296.376 888.972 296.448C869.239 296.95 849.578 296.878 829.917 296.448C828.41 296.448 828.338 294.081 829.917 294.081Z",
  fill: "#2B314F"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M829.917 307.707C849.578 307.707 869.311 307.349 888.972 306.847C891.053 306.775 891.053 310.002 888.972 310.074C869.239 310.576 849.578 310.504 829.917 310.074C828.41 310.074 828.338 307.707 829.917 307.707Z",
  fill: "#2B314F"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M829.917 322.768C849.578 322.768 869.311 322.409 888.972 321.907C891.053 321.835 891.053 325.062 888.972 325.134C869.239 325.636 849.578 325.564 829.917 325.134C828.41 325.134 828.338 322.768 829.917 322.768Z",
  fill: "#2B314F"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M909.206 239.865C909.35 282.033 909.637 324.202 910.068 366.371C910.068 368.45 906.838 368.45 906.838 366.371C906.408 324.202 906.408 282.033 906.767 239.865C906.838 238.359 909.206 238.359 909.206 239.865Z",
  fill: "#2B314F"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M925.553 330.209C921.75 328.559 918.808 325.404 917.373 321.244C915.866 316.941 916.153 312.28 918.162 308.407C922.539 300.232 930.648 299.156 936.747 301.666C943.348 304.463 948.515 311.706 945.788 320.312C945.358 321.961 944.568 323.468 943.42 324.974C940.335 328.99 935.67 331.285 931.006 331.285C929.141 331.285 927.275 330.926 925.553 330.209ZM920.028 309.411C918.305 312.71 918.019 316.798 919.382 320.527C920.674 324.113 923.113 326.838 926.414 328.201C931.652 330.424 937.967 328.559 941.698 323.683C942.703 322.392 943.348 321.101 943.707 319.738C946.075 312.352 941.554 306.112 935.886 303.674C934.307 303.029 932.513 302.598 930.648 302.598C926.773 302.598 922.683 304.391 920.028 309.411Z",
  fill: "#2B314F"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M894.841 282.088C894.769 282.088 894.769 282.088 894.698 282.088C894.913 281.944 895.128 281.801 895.343 281.729C895.272 281.801 895.272 281.801 895.2 281.873C894.769 282.375 893.98 282.446 893.406 282.231C892.832 282.016 892.33 281.371 892.401 280.725C892.401 280.152 892.688 279.578 893.191 279.291C893.765 278.932 894.698 279.004 895.2 279.578C895.272 279.65 895.272 279.65 895.343 279.721C895.128 279.578 894.913 279.434 894.698 279.363C894.769 279.363 894.769 279.363 894.841 279.363C896.204 279.578 896.204 281.801 894.841 282.088Z",
  fill: "#2B314F"
});

var _ref96 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M888.384 286.176C890.393 286.176 890.393 283.092 888.384 283.092C886.375 283.092 886.375 286.176 888.384 286.176Z",
  fill: "#2B314F"
})));

var _ref97 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M881.925 289.618C883.719 289.618 883.719 286.821 881.925 286.821C880.059 286.821 880.059 289.618 881.925 289.618Z",
  fill: "#2B314F"
})));

var _ref98 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M876.543 294.423C878.624 294.423 878.624 291.196 876.543 291.196C874.462 291.267 874.462 294.423 876.543 294.423Z",
  fill: "#2B314F"
})));

var _ref99 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M869.799 297.865C869.799 297.793 869.799 297.722 869.799 297.65C869.871 297.865 869.943 298.08 870.014 298.295C870.014 298.295 870.015 298.224 869.943 298.224C869.44 297.291 870.086 296.072 871.163 296.072C872.239 296.072 872.885 297.291 872.383 298.224C872.383 298.224 872.382 298.295 872.311 298.295C872.382 298.08 872.454 297.865 872.526 297.65C872.526 297.722 872.526 297.793 872.526 297.865C872.454 298.582 871.952 299.228 871.234 299.156C870.373 299.156 869.871 298.582 869.799 297.865Z",
  fill: "#2B314F"
});

var _ref100 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M866.856 303.315C868.794 303.315 868.794 300.232 866.856 300.232C864.847 300.303 864.847 303.315 866.856 303.315Z",
  fill: "#2B314F"
})));

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M863.125 283.522L863.914 404.291C863.914 406.012 865.349 407.375 867.215 407.375L957.772 406.801C955.332 410.53 958.274 403.215 958.274 401.494L956.91 284.024C956.91 283.379 956.839 282.733 956.767 282.088C956.265 279.004 953.179 281.012 956.049 280.94C957.484 280.94 949.017 280.08 945.716 280.08L866.354 280.367C864.56 280.438 863.125 281.801 863.125 283.522Z",
  fill: "url(#paint1_linear)"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M864.13 278.861C895.201 278.861 926.343 278.502 957.413 278C959.494 278 959.494 281.155 957.413 281.227C926.271 281.729 895.201 281.729 864.13 281.227C862.623 281.227 862.623 278.861 864.13 278.861Z",
  fill: "#2B314F"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M864.13 405.08C895.201 405.08 926.343 404.721 957.413 404.219C959.494 404.219 959.494 407.375 957.413 407.446C926.271 407.948 895.201 407.948 864.13 407.446C862.623 407.446 862.623 405.08 864.13 405.08Z",
  fill: "#2B314F"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M865.925 279.865C866.069 322.033 866.356 364.202 866.786 406.371C866.786 408.45 863.557 408.45 863.557 406.371C863.127 364.202 863.127 322.033 863.485 279.865C863.557 278.359 865.925 278.359 865.925 279.865Z",
  fill: "#2B314F"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M879.917 296.789C894.771 296.718 909.767 296.431 924.621 295.929C926.702 295.857 926.702 299.084 924.621 299.156C909.696 299.658 894.842 299.586 879.917 299.156C878.41 299.156 878.338 296.789 879.917 296.789Z",
  fill: "#2B314F"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M879.917 319.738C899.578 319.738 919.311 319.38 938.972 318.878C941.053 318.806 941.053 322.033 938.972 322.105C919.239 322.607 899.578 322.535 879.917 322.105C878.41 322.105 878.338 319.738 879.917 319.738Z",
  fill: "#2B314F"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M879.917 334.081C899.578 334.081 919.311 333.723 938.972 333.221C941.053 333.149 941.053 336.376 938.972 336.448C919.239 336.95 899.578 336.878 879.917 336.448C878.41 336.448 878.338 334.081 879.917 334.081Z",
  fill: "#2B314F"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M879.917 347.707C899.578 347.707 919.311 347.349 938.972 346.847C941.053 346.775 941.053 350.002 938.972 350.074C919.239 350.576 899.578 350.504 879.917 350.074C878.41 350.074 878.338 347.707 879.917 347.707Z",
  fill: "#2B314F"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M879.917 362.768C899.578 362.768 919.311 362.409 938.972 361.907C941.053 361.835 941.053 365.062 938.972 365.134C919.239 365.636 899.578 365.564 879.917 365.134C878.41 365.134 878.338 362.768 879.917 362.768Z",
  fill: "#2B314F"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M959.206 279.865C959.35 322.033 959.637 364.202 960.068 406.371C960.068 408.45 956.838 408.45 956.838 406.371C956.408 364.202 956.408 322.033 956.767 279.865C956.838 278.359 959.206 278.359 959.206 279.865Z",
  fill: "#2B314F"
});

var _ref111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 860.699,
  y1: 240.08,
  x2: 860.699,
  y2: 367.846,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.34375,
  stopColor: "#BFCDE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.708333,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.99
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 910.699,
  y1: 280.08,
  x2: 910.699,
  y2: 407.846,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.34375,
  stopColor: "#BFCDE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.708333,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.99
})));

function SvgSlide1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1292 542",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1);
export default __webpack_public_path__ + "static/media/slide1.51a3a595.svg";
export { ForwardRef as ReactComponent };